import { render, staticRenderFns } from "./ModalFFAgeWarning.vue?vue&type=template&id=67f934ca"
import script from "./ModalFFAgeWarning.vue?vue&type=script&lang=js"
export * from "./ModalFFAgeWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@6.26.3_css-loader@6.11.0_webpack_0adae5f353b25b49b54638f9fc4b63b8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports